
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/prime",
      function () {
        return require("private-next-pages/goal/[goalSlug]/[goalUID]/prime.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goal/[goalSlug]/[goalUID]/prime"])
      });
    }
  